module.exports = __webpack_public_path__ + "static/media/preview-linkedin-active.82e11399.svg";